import Vue from 'vue'
import Router from 'vue-router'
import Home from '../view/home'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/home',
      redirect: '/'
    },
    // 首页
    {
      path: '/home',
      name: 'home',
      component: Home,
      meta: {
        title: '首页',
        requireAuth: true
      }
    },
    {
      path: '/productCenter',
      name: 'productCenter',
      component: resolve => require(['@/view/productCenter'], resolve),
      meta: {
        title: '产品中心',
        requireAuth: true
      }
    },
    {
      path: '/contact',
      name: 'contact',
      component: resolve => require(['@/view/contact'], resolve),
      meta: {
        title: '联系我们',
        requireAuth: true
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js